<div class="telemetry-map-container">
  <!-- Controles do Mapa -->
  <div class="map-controls" *ngIf="showControls">
    <button class="btn btn-sm btn-light" (click)="centerOnVehicle()" [title]="'telemetry.buttons.centerVehicle' | transloco">
      <i class="bi bi-crosshair"></i>
    </button>
    <button class="btn btn-sm btn-light" (click)="toggleHistory()" [title]="'telemetry.buttons.toggleHistory' | transloco">
      <i class="bi bi-bezier2"></i>
    </button>
    <button class="btn btn-sm btn-light" (click)="clearHistory()" [title]="'telemetry.buttons.clearHistory' | transloco">
      <i class="bi bi-trash"></i>
    </button>
    <button class="btn btn-sm btn-light" (click)="fitBounds()" [title]="'telemetry.buttons.fitRoute' | transloco">
      <i class="bi bi-arrows-fullscreen"></i>
    </button>
  </div>

  <!-- Container do Mapa Leaflet -->
  <div id="telemetry-map" #mapContainer [style.height]="height"></div>
</div>
